import Routes from 'Routes'

const { about, careers, termsOfUseEleven } = Routes

export const generalTerms = [
  {
    text: 'Política de Privacidade',
    link: 'https://www.onze.com.br/politica-de-privacidade',
  },
  {
    text: 'Termos de uso Onze',
    link: termsOfUseEleven.path,
  },
  {
    text: 'Aviso de privacidade para candidatos',
    link:
      'https://www.onze.com.br/blog/wp-content/uploads/2023/04/Aviso-de-privacidade-para-candidatos.docx.pdf',
  },
]

export const socialMediaLinks = [
  {
    link: 'https://www.facebook.com/onzeprevidencia',
    icon: 'facebook',
  },
  {
    link: 'https://www.instagram.com/onzeofficial',
    icon: 'instagram',
  },
  {
    link: 'https://www.linkedin.com/company/onze-oficial',
    icon: 'linkedin',
  },
]

export const usefulLinks = [
  {
    text: 'Quem somos',
    link: about.path,
  },
  {
    text: 'Vagas',
    link: careers.path,
  },
  {
    text: 'Blog',
    link: 'https://www.onze.com.br/blog/',
  },
  {
    text: 'Ferramentas',
    link: 'https://www.onze.com.br/blog/calculadora-da-previdencia/',
  },
  {
    text: 'Contato',
    link: 'mailto:contato@onze.com.br',
  },
]

export const contactLinks = [
  {
    text: 'Suporte e Dúvidas - WhatsApp: (11) 3164-4814',
    link: 'https://api.whatsapp.com/send?phone=551131644814',
  },
  {
    text: 'Marketing e Vendas - contato@onze.com.br',
    link: 'mailto:contato@onze.com.br',
  },
  {
    text: 'Imprensa - raisa@onze.com.br',
    link: 'mailto:raisa@onze.com.br',
  },
  {
    text: 'Fraudes e Roubos - fraudes@onze.com.br',
    link: 'mailto:fraudes@onze.com.br',
  },
]
